(function ($) {
    $(document).ready(function () {
        var touchMoved;

        //Constant class
        var CHILD_OF_DROPDOWN = '.nav__item.is-dropdown > .nav__link';
        var IS_DROPDOWN = '.nav__item.is-dropdown';
        var IS_DROPDOWN_IS_ACTIVE = '.nav__item.is-dropdown.is-active';

        touchDevicesLinkRegistration();

        $(window).on('orientationchange', function () {
            touchDevicesLinkRegistration();
        })

        function touchDevicesLinkRegistration() {
            if (is_touch_device() && $(window).width() > 991) {
                var $dropdownLinks = $('.nav__item.is-dropdown .nav__list a');
                $dropdownLinks.click(function () {
                    window.location = $(this).attr('href');
                });
            }
        }

        function toggleTouchDeviceOnlyLinks() {
            var $toggleItems = $('.nav .nav__item--visibleOnTouchDeviceOnly');

            if ($(window).width() < 992) {
                $toggleItems.each(function () {
                    $(this).removeClass('nav__item--visibleOnTouchDeviceOnlyActive');
                });
            } else {

                if (is_touch_device()) {
                    $toggleItems.each(function () {
                        $(this).addClass('nav__item--visibleOnTouchDeviceOnlyActive');
                        $(this).removeClass('nav__item--visibleOnTouchDeviceOnly');
                    });
                }
            }

        }

        $('.nav__item.is-dropdown').click(function (event) {
            toggleTouchDeviceOnlyLinks();
            if (is_touch_device() && $(window).width() > 991) {
                event.stopPropagation();
                event.preventDefault();
            }
        });

        $('.nav__item .nav__link-parent').click(function (event) {
            toggleTouchDeviceOnlyLinks();
            if (is_touch_device() && $(window).width() > 991) {
                event.stopPropagation();
                event.preventDefault();
            }
        });

        $('.nav__item.is-dropdown .nav__link.nav__link--1').click(function (event) {
            toggleTouchDeviceOnlyLinks();
            if (is_touch_device() && $(window).width() > 991) {
                event.stopPropagation();
                event.preventDefault();
            }
        });

        function is_touch_device() {
            var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

            var mq = function (query) {
                return window.matchMedia(query).matches;
            }

            if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
                return true;
            }

            var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
            return mq(query);
        }

        // Touch Device Detection - when testing make sure you are in Responsive mode NOT screen width.
        var isTouchDevice = 'ontouchstart' in document.documentElement;

        $('.nav').on('click tap', CHILD_OF_DROPDOWN, function (e) {
            if ($(window).innerWidth() < 991) {
                e.preventDefault();
                //if (touchMoved === true) return; // If scrolling

                var $submenu = $(this).closest(IS_DROPDOWN);
                var $currentOpenSubmenus = $(IS_DROPDOWN_IS_ACTIVE);

                if ($submenu.hasClass('is-active')) {
                    var openItemCount = $(IS_DROPDOWN_IS_ACTIVE).length;
                    if (openItemCount <= 1) {
                        closeNav();
                    }
                } else {
                    $('.nav').addClass('is-active');
                    $('body').addClass('mobileNav-open');
                    $submenu.addClass('is-active');
                }
            }
        })
        //}).on('touchmove', function () { touchMoved = true; }).on('touchstart', function () { touchMoved = false; });

        $('.nav__back').on('click', function () {
            $(this).closest(IS_DROPDOWN_IS_ACTIVE).removeClass('is-active');
        });

        $('.nav_overlay').on('click', function () {
            closeNav();
        });

        $('.mobileNav__toggle').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);

            $('.nav').addClass('is-active');
            $('.mobileNavPanel').addClass('is-active');
            $('body').addClass('mobileNav-open');

            $this.toggleClass('icon-change');
            
            if ($this.hasClass('icon-change') === false) {
                closeNav();
                // PUT THIS IN CLOSE -> $('.nav-wrapper--mobile-inner').animate({ left: "-" + $('.nav-wrapper--mobile-inner').width() }, 1000);
            } else {
                $('.nav-wrapper--mobile-inner').animate({ left: "0" }, 1000);
            }

            

            updateMobileMenuToggle();
            //updateNavHeight();
        });

        setMobileActiveLevel();

        //Mobile accordion nav toggle
        //if (is_touch_device() && $(window).width() > 991) {
        //$(".nav-menu__label").on('click', function (e) {
        //    e.preventDefault();
        //    var $this = $(this);


        //    if ($this.hasClass('show')) {

        //        $this.removeClass('show');
        //        $this.next().slideUp(350);
        //    }
        //    else {
        //        $this.removeClass('show');
        //        $this.parent().parent().find('ul').slideUp(350);
        //        $this.toggleClass('show');
        //        $this.next().slideToggle(350);
        //    }

        //});
        //}
    });

    function updateMobileMenuToggle() {
        var $menuToggle = $('.mobileNav__toggle');
        var $menuText = $menuToggle.find('.menuText');
        let updateText;

        if ($menuToggle.hasClass('icon-change')) {
            updateText = $menuText.attr('data-close-text');
        } else {
            updateText = $menuText.attr('data-open-text');
        }

        $menuText.text(updateText);

        
    }

    //function updateNavHeight() {
    //    var newHeight = $("body").innerHeight() - $("header .nav_mobile-header").innerHeight();
    //    $('header .nav__list').css({ 'height': newHeight });
    //    $('header .nav__overlay').css({ 'height': $("body").innerHeight() });
    //}

    function closeNav() {
        $('.mobileNavPanel, .nav, .nav__item.is-dropdown').removeClass('is-active');
        $('.mobileNav__toggle').removeClass('icon-change');

        updateMobileMenuToggle();
        setTimeout(function () {
            $('body').removeClass('mobileNav-open');
        }, 600);

        $('.nav-wrapper--mobile-inner').animate({ left: "-" + $('.nav-wrapper--mobile-inner').width() -100 }, 1000);
    }

    function setMobileActiveLevel() {
        $(".flyout").find(".nav__link--active").parents('.nav__item.is-dropdown').addClass("is-active");
    }



})(jQuery);